import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import FloatingIcons from "./FloatingIcons";

const Layout = () => {
  return (
    <>
      <FloatingIcons />
      <Header />
      <Outlet />
      <Footer />
    </>
  );
};

export default Layout;
